import { inject } from '@angular/core';

import { CONFIG_TOKEN } from '@core/tokens';

export const isProduction = (): boolean => {
  return inject(CONFIG_TOKEN).appEnvironmentId.toLowerCase() === 'production';
};
